import { render, staticRenderFns } from "./FbPreviewSettings.vue?vue&type=template&id=3f0551f0"
import script from "./FbPreviewSettings.vue?vue&type=script&lang=js"
export * from "./FbPreviewSettings.vue?vue&type=script&lang=js"
import style0 from "./FbPreviewSettings.vue?vue&type=style&index=0&id=3f0551f0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0551f0')) {
      api.createRecord('3f0551f0', component.options)
    } else {
      api.reload('3f0551f0', component.options)
    }
    module.hot.accept("./FbPreviewSettings.vue?vue&type=template&id=3f0551f0", function () {
      api.rerender('3f0551f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/FbPreviewSettings.vue"
export default component.exports